import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth-provider";
import { ThemeProvider } from "@/lib/theme-provider";
import LoginPage from "@/pages/LoginPage";
import LandingPage from "@/pages/LandingPage";
import ScenesPage from "@/pages/ScenesPage";
import LessonPage from "@/pages/LessonPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboardPage from "@/pages/admin/DashboardPage";
import SceneBuilderPage from "@/pages/admin/SceneBuilderPage";
import RequireAuth from "@/components/RequireAuth";
import RequireAdmin from "@/components/RequireAdmin";
import BottomNav from "@/components/BottomNav";

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* user-facing pages */}
        <Route
          path="/"
          element={
            <RequireAuth>
              <Navigate to="/landing" replace />
            </RequireAuth>
          }
        />
        <Route
          path="/landing"
          element={
            <RequireAuth>
              <LandingPage />
            </RequireAuth>
          }
        />
        <Route
          path="/scenes"
          element={
            <RequireAuth>
              <ScenesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/lesson"
          element={
            <RequireAuth>
              <LessonPage />
            </RequireAuth>
          }
        />

        {/* admin section — one gate protects everything nested */}
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<AdminDashboardPage />} />
          <Route path="scene-builder/:sceneSlug" element={<SceneBuilderPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNavExceptOnLogin />
    </AuthProvider>
    </ThemeProvider>
  );
}

function BottomNavExceptOnLogin() {
  const location = useLocation();
  if (location.pathname === "/login") return null;
  return <BottomNav />;
}
